import { removeDecimalZero } from './number';

export function vxeTableRemoveZeroFormatter({ cellValue }) {
  return removeDecimalZero(cellValue);
}

export function vxeTableBooleanFormatter({ cellValue }) {
  return cellValue ? '是' : '否';
}

export function generateVxeTableEnumFormatter(enumObj: Record<any, any>, nilFallback = '') {
  return function ({ cellValue }) {
    return enumObj[cellValue] ?? nilFallback;
  };
}
